import { createFileRoute } from '@tanstack/react-router';
import { Pane } from '@sheridan-prize/ui';
import { ResetPassword } from '../components/ResetPassword';
import { getAuthStore } from '../main';
import { AccountHeader } from '../components/AccountHeader';

export const Route = createFileRoute('/reset-password')({
  beforeLoad: async () => {
    await getAuthStore().fetchUser();
  },
  component: ResetForm,
});

function ResetForm() {
  return (
    <>
      <AccountHeader />
      <div className="app">
        <div style={{ gridArea: 'main / sidebar / main / main' }}>
          <Pane classes={'sp-register sp-login'} tag="main">
            <ResetPassword />
          </Pane>
        </div>
      </div>
    </>
  );
}
